'use strict';

angular.module('internal.investigations')
    .controller('InternalInvestigationDocuments', ['$scope', '$rootScope', 'DocumentTypes', 'Documents', '$timeout', function ($scope, $rootScope, DocumentTypes, Documents, $timeout) {
        $scope.resetInvestigation();
        $scope.loading = true;
        $scope.bulkActionItems = [];
        $scope.bulkActionRunning = false;

        // Download progress state
        $scope.downloadProgress = {
            active: false,
            percent: 0,
            status: '',
            error: null,
            loaded: 0,
            total: 0
        };

        $scope.downloadZip = function (bulkApply) {
            if ($scope.bulkActionItems && $scope.bulkActionItems.length > 0) {
                $scope.bulkActionRunning = true;
                $scope.downloadProgress = {
                    active: true,
                    percent: 0,
                    status: 'Starting download...',
                    error: null,
                    loaded: 0,
                    total: 0
                };
                bulkApply.isOpen = false;

                let onProgress = function (progress) {
                    $scope.$apply(function () {
                        $scope.downloadProgress.loaded = progress.loaded;
                        $scope.downloadProgress.total = progress.total;
                        $scope.downloadProgress.percent = progress.percent;

                        let loadedMB = (progress.loaded / 1024 / 1024).toFixed(2);
                        let totalMB = (progress.total / 1024 / 1024).toFixed(2);
                        $scope.downloadProgress.status = 'Downloading: ' + loadedMB + ' MB / ' + totalMB + ' MB';
                    });
                };

                $scope.activeDownload = Documents.downloadZipWithProgress($scope.bulkActionItems, onProgress);
                const activeDownload = $scope.activeDownload;
                activeDownload
                    .then(function (response) {
                        // A stale promise (the user cancelled or started another download) must not tear down the
                        // current download's UI state or drop its abort handle.
                        if ($scope.activeDownload !== activeDownload) {
                            return;
                        }
                        if (response && response.data) {
                            $scope.downloadProgress.percent = 100;
                            $scope.downloadProgress.status = 'Download complete, saving file...';
                            
                            let link = document.createElement("a");
                            link.setAttribute("type", "hidden");
                            link.href = URL.createObjectURL(response.data);
                            link.download = "download.zip";
                            
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            URL.revokeObjectURL(link.href);
                            
                            // Hide progress overlay after brief delay
                            $timeout(function() {
                                $scope.downloadProgress.active = false;
                                $scope.bulkActionRunning = false;
                            }, 1500);
                        } else {
                            $scope.downloadProgress.error = 'Download failed: No data received';
                            $scope.downloadProgress.active = false;
                            $scope.bulkActionRunning = false;
                        }
                        $scope.activeDownload = null;
                    })
                    .catch(function (error) {
                        // Ignore rejections from a download that is no longer the active one (e.g. an aborted
                        // previous request) so it cannot switch off a freshly started download.
                        if ($scope.activeDownload !== activeDownload) {
                            return;
                        }
                        if (error.statusText === 'Download aborted') {
                            $scope.downloadProgress.status = 'Download cancelled';
                        } else {
                            $scope.downloadProgress.error = 'Download failed: ' + (error.statusText || 'Unknown error');
                        }
                        $scope.downloadProgress.active = false;
                        $scope.bulkActionRunning = false;
                        $scope.activeDownload = null;
                    });
            }
        };
        
        $scope.cancelDownload = function () {
            // Abort the in-flight fetch so the server stops streaming instead of finishing in the background.
            if ($scope.activeDownload && $scope.activeDownload.abort) {
                $scope.activeDownload.abort();
            }
            $scope.activeDownload = null;
            $scope.downloadProgress.active = false;
            $scope.downloadProgress.status = 'Download cancelled by user';
            $scope.bulkActionRunning = false;
        };

        DocumentTypes.get({ check_permission: true }).then(function (types) {
            $scope.types = types;

            Documents.storageAvailable().then(response => {
                let document = {
                    id: 'id',
                    code: 'code',
                    url: $rootScope.internalURL + 'controller.cfm?method=publicPortalService.openDocument',
                }

                $scope.columns = [
                    {
                        label: 'Name',
                        field: 'name',
                        hideActionPermission: {
                            types: $scope.types,
                            field: 'document_type_id'
                        },
                        link: {
                            state: 'internal.licensing.investigation.document',
                            params: [
                                {
                                    name: 'investigationDocumentID',
                                    field: 'id'
                                },
                                {
                                    name: 'investigation_document',
                                    field: ''
                                }
                            ]
                        }
                    },
                    {
                        label: 'Type',
                        field: 'document_type.name'
                    },
                    {
                        label: 'File',
                        field: 'file_name',
                        type: 'file',
                        permission: {
                            types: $scope.types,
                            field: 'document_type_id'
                        },
                        document: document
                    },
                    {
                        label: 'Expiration Date',
                        field: 'expiration_date',
                        type: 'date'
                    },
                    {
                        label: 'Size',
                        field: 'file_size',
                        type: 'file_size'
                    },
                    {
                        label: 'Created On',
                        field: 'createdon',
                        type: 'date'
                    },
                    {
                        label: 'Created By',
                        field: 'createdby'
                    }
                ];

                $scope.loading = false;
            })
        })        

        $scope.filters = [
            {
                name: 'Document Type',
                field: 'document_type_id',
                service: 'DocumentTypes'
            }
        ];
    }])
;